import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Axios from "../../api/axios/Axios";

import PageWrapper from "../../components/layout/page/PageWrapper";
import PageHeader from "../../components/layout/page/PageHeader";
// import { PageHeading } from "../../components/common/heading/Heading";

import BackButton from "../../components/buttons/back/BackButton";
import TextField from "../../components/input/textfield/TextField";
import TextArea from "../../components/input/textarea/TextArea";
import Select from "../../components/input/select/Select";
import StatusAlert from "../../components/alerts/StatusAlert";
import FeedbackStatus from "../../components/feedback/FeedbackStatus";
import Button from "../../components/buttons/Button";

import "./SupportPage.css";

const SUBJECTS = [
  { value: "General", label: "General" },
  { value: "Technical support", label: "Technical support" },
  { value: "Queries about payments", label: "Queries about payments" },
  { value: "I can't log in", label: "I can't log in" },
  { value: "Copyright infringement", label: "Copyright infringement" },
  { value: "I can't watch videos", label: "I can't watch videos" },
  { value: "Account recovery", label: "Account recovery" },
  { value: "Privacy concerns", label: "Privacy concerns" },
  { value: "Feedback submission", label: "Feedback submission" },
  { value: "Other", label: "Other" },
];

export default function SupportPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "General",
    message: "",
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: "",
  });

  useEffect(() => {
    document.title = "Katch | Support";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubjectChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      subject: e.target.value,
    }));
  };

  const validate = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (formData.fullName.trim().length < 2) {
      return "Please enter your name.";
    }

    if (!emailPattern.test(formData.email.trim())) {
      return "Please enter a valid email address.";
    }

    if (formData.message.trim().length < 10) {
      return "Message must be at least 10 characters.";
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (status.loading) return;

    const error = validate();

    if (error) {
      setStatus((prev) => ({
        ...prev,
        error,
      }));
      return;
    }

    setStatus({
      loading: true,
      success: false,
      error: "",
    });

    try {
      const response = await Axios.post("/api/v1/support", {
        name: formData.fullName.trim(),
        email: formData.email.trim(),
        subject: formData.subject.trim(),
        message: formData.message.trim(),
      });

      if (!response.data?.success) {
        throw new Error("Support request was not successful.");
      }

      setStatus({
        loading: false,
        success: true,
        error: "",
      });
    } catch (error) {
      console.error("Support submission failed:", error);

      setStatus({
        loading: false,
        success: false,
        error: "Failed to send message. Please try again later.",
      });
    }
  };

  return (
    <PageWrapper size="sm">
      <br />
      <br />

      <BackButton onClick={() => navigate(-1)} />

      <br />
      <br />

      <PageHeader
        title="Contact Us"
        description="Need help? Send us a message and our support team will get back to you."
      />

      <div>
        {status.success ? (
          <FeedbackStatus
            title="Message sent"
            description="Thank you for reaching out. We've received your message and our support team will respond as soon as possible."
            buttonText="Return Home"
            onAction={() => navigate("/")}
          />
        ) : (
          <form
            className="support-page__form"
            onSubmit={handleSubmit}
            noValidate
          >
            {status.error && (
              <StatusAlert
                status={{
                  status: "error",
                  message: status.error,
                }}
              />
            )}

            <TextField
              label="Your name"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Enter your full name"
              required
            />

            <TextField
              type="email"
              label="Your email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="email@domain.com"
              required
            />

            <Select
              label="Subject"
              value={formData.subject}
              items={SUBJECTS}
              onChange={handleSubjectChange}
              required
            />

            <TextArea
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="How can we help you today?"
              rows={5}
              required
            />

            <div className="support-page__actions">
              <Button
                type="submit"
                variant="primary"
                value={status.loading ? "Sending message..." : "Send message"}
                disabled={status.loading}
              />
            </div>
          </form>
        )}
      </div>
    </PageWrapper>
  );
}
